import {
  actionCreator,
  API_URL,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrl,
  jsonApiHeader,
  showErrorMessage,
  showSuccessMessage,
  showWarningMessage,
} from '../../../../../../../actions/utilAction';

export { 
  jsonApiHeader, 
  showWarningMessage, 
  showErrorMessage, 
  actionCreator, 
  checkHttpStatus, 
  create_post_data, 
  createSearchUrl, 
  showSuccessMessage 
};

export const GET_RAWABCDATA_LIST_API = `${API_URL}/api/CollectData/GetRecordedABCDataByPatientId`;
export const DELETE_RAWABCDATA_API = `${API_URL}/api/CollectData/DeleteRecordedABCDataByRecordABCDataId`;

export const rawAbcDataActionTypes = {
  get_rawABCDataList: createRequestActionTypes('GET_RAWABCDATALIST'),
  delete_rawABCData: createRequestActionTypes('DELETE_RAWABCDATA'),
};


// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/BehaviorReductiom/RawABCData/constants/ApiConstants.js